
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { FeatureName } from './feature';
import { NewAccountStoreReducer } from './reducer';
import { NewAccountStoreEffects } from './effects';


@NgModule({
	imports: [
		CommonModule,
		StoreModule.forFeature(FeatureName, NewAccountStoreReducer),
		EffectsModule.forFeature([NewAccountStoreEffects])
	]
})

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class NewAccountStoreModule { }
